import React, { Component } from 'react';

import { Box } from 'components';

class AddressList extends Component {
  copyToClipboard = address => {
    this.textArea.select();
    document.execCommand('copy');
  };

  render() {
    const { data, scroll } = this.props;
    return (
      <Box
        py="4"
        style={{
          overflowY: scroll ? 'scroll' : 'visible',
          height: scroll ? '300px' : 'auto',
        }}
      >
        {data &&
          data.map(address => (
            <Box
              flex
              mb="2"
              onClick={this.copyToClipboard}
              style={{
                wordBreak: 'break-word',
              }}
              key={address.wallet_address}
            >
              <Box pr="3">{address.wallet_address}</Box>
              <input
                type="hidden"
                ref={textarea => (this.textArea = textarea)}
                value={address.wallet_address}
              />
              <Box ml="auto">
                <img
                  alt="copy address"
                  className="mr-2"
                  src={require('../../images/copy.svg')}
                  width={18}
                  height={18}
                />
              </Box>
            </Box>
          ))}
      </Box>
    );
  }
}

export default AddressList;
